// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-logo[data-v-66a387bc]{max-width:20px;margin-right:-10px}.v-toolbar--fixed.theme--dark[data-v-66a387bc]{padding-right:0!important}.filter-icon:hover path[data-v-66a387bc]{fill:#fff}.filter-icon path[data-v-66a387bc]{fill:#bcbcbc;transition:all .6s}.user-avatar[data-v-66a387bc]{display:flex;align-items:center}.user-avatar p[data-v-66a387bc]{color:#3f3f3f;margin-top:15px;margin-right:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
